import React, { Component } from "react"
import HeroSection from "./hero-section"
import WhoWeAreSection from "./who-we-are-section"
import OurSkills from "../Home/our-skills-section"

import "./about.css"
import OurTeamSection from "./our-team-section"

class AboutUs extends Component {
  render() {
    return (
      <React.Fragment>
        <HeroSection />
        <WhoWeAreSection />
        <OurSkills />
        <OurTeamSection />
      </React.Fragment>
    )
  }
}

export default AboutUs
